import React, { useMemo } from "react";
import { CChartLine } from "@coreui/react-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils";

// const brandSuccess = getStyle("success") || "#4dbd74";
const brandInfo = getStyle("info") || "#20a8d8";
// const brandDanger = getStyle("danger") || "#f86c6b";

/*
// ---------- OLD CODE (chart re-rendered with new random data on every parent state change) ----------
const MainChartExample = (attributes) => {
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const defaultDatasets = (() => {
    let elements = 27;
    const data1 = [];
    for (let i = 0; i <= elements; i++) {
      data1.push(random(50, 200));
    }
    return [
      {
        label: "My First dataset",
        backgroundColor: hexToRgba(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: brandInfo,
        borderWidth: 2,
        data: data1,
      },
    ];
  })();

  const defaultOptions = (() => {
    return {
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              drawOnChartArea: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(250 / 5),
              max: 250,
            },
            gridLines: {
              display: true,
            },
          },
        ],
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3,
        },
      },
    };
  })();

  return (
    <CChartLine
      {...attributes}
      datasets={defaultDatasets}
      options={defaultOptions}
      labels={[
        "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
        "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
        "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
        "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
      ]}
    />
  );
};
// ---------- END OLD CODE ----------
*/

const MainChartExample = (attributes) => {
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const defaultDatasets = useMemo(() => {
    let elements = 27;
    const data1 = [];
    for (let i = 0; i <= elements; i++) {
      data1.push(random(50, 200));
    }
    return [
      {
        label: "My First dataset",
        backgroundColor: hexToRgba(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: brandInfo,
        borderWidth: 2,
        data: data1,
      },
    ];
  }, []);

  const defaultOptions = useMemo(() => {
    return {
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              drawOnChartArea: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(250 / 5),
              max: 250,
            },
            gridLines: {
              display: true,
            },
          },
        ],
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3,
        },
      },
    };
  }, []);

  const labels = useMemo(
    () => [
      "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
      "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
      "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
      "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su",
    ],
    []
  );

  return (
    <CChartLine
      {...attributes}
      datasets={defaultDatasets}
      options={defaultOptions}
      labels={labels}
    />
  );
};

export default MainChartExample;
